
import {Component, Vue} from "vue-property-decorator";
import VueSection from "../components/section/index.vue";

@Component({
    components: {
        VueSection
    }
})
export default class HomeClass extends Vue {



    mounted(){
        window.scrollTo(0, 0);
    }
}
